<template>
  <CockpitDialog
    title="新增事故事件"
    left="630px"
    width="890px"
    height="550px"
    top="120px"
    @close="$emit('close')"
  >
    <div class="h-full flex flex-col">
      <div class="w-full flex-1 h-0 overflow-y-auto">
        <el-form
          :model="formData"
          :rules="formRules"
          ref="formRef"
          label-width="110px"
          class="overflow-hidden"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="`${$t('事故事件名称')}`" prop="Name">
                <el-input
                  class="mr-10px w-full"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.Name"
                  clearable
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('事故编码')}`" prop="Code">
                <el-input
                  class="mr-10px w-full"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.Code"
                  clearable
                  maxlength="15"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('事故类别')}`" prop="Category">
                <el-select
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="small"
                  v-model="formData.Category"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in accidentType"
                    :key="item.value"
                    :label="item.displayName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('事故风险等级')}`" prop="Level">
                <el-select
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="small"
                  v-model="formData.Level"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in accidentLevel"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('事故地点')}`" prop="Site">
                <el-select
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="small"
                  v-model="formData.Site"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in riskList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('事故性质')}`" prop="Nature">
                <el-select
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="small"
                  v-model="formData.Nature"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in accidentNature"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="事故时间" prop="OccurTime">
                <el-date-picker
                  popper-class="visualization-picker-popper"
                  size="small"
                  v-model="formData.OccurTime"
                  class="!w-full"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="发生时间"
                  :picker-options="timeLimit"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="15">
              <el-form-item label="事故快照" prop="fileArr">
                <uploadCom
                  ref="uploadCom"
                  :fileTypeList="fileTypeList"
                  :fileMaxSize="20"
                  @update:file="updateFile"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="text-center mt-10px flex justify-center">
        <button
          type="button"
          @click="subData"
          class="handle_btn mr-10px"
          v-loading="formLoading"
          :disable="formLoading"
        >
          保存
        </button>
        <button class="handle_btn" type="button" @click="$emit('close')">
          取消
        </button>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import { FormApi } from '@wiz-api/safety-factor-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { AreaApi } from '@wiz-api/area-management'
import { PlanApi } from '@wiz-api/emergency-management'
import uploadCom from './uploadCom'

const formApi = new FormApi()
const dataCategoryApi = new DataCategoryApi()
const areaApi = new AreaApi()
const planApi = new PlanApi()

export default {
  name: 'AccidentDialog',
  components: { uploadCom, CockpitDialog },
  watch: {},
  data() {
    return {
      formData: {
        Name: '',
        Category: '',
        Level: '',
        Site: '',
        Plan: '',
        Nature: '',
        Code: '',
        OccurTime: '',
        Snapshot: '',
      }, // 表单数据
      formLoading: false,
      accidentNature: [],
      accidentLevel: [
        {
          value: 1,
          label: '特别重大事故',
        },
        {
          value: 2,
          label: '重大事故',
        },
        {
          value: 3,
          label: '较大事故',
        },
        {
          value: 4,
          label: '一般事故',
        },
      ],
      accidentType: [],
      riskList: [],
      planList: [],
      fileTypeList: ['doc', 'docx', 'pdf', 'xls', 'xlsx'],
      timeLimit: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
        selectableRange: '00:00:00 - 23:59:59',
      },
    }
  },
  computed: {
    formRules() {
      return {
        Name: [{ required: true, message: this.$t('请输入'), trigger: 'blur' }],
        Category: [{ required: true, message: this.$t('请选择'), trigger: ['blur', 'change'] }],
        Level: [{ required: true, message: this.$t('请选择'), trigger: ['blur', 'change'] }],
        Site: [{ required: true, message: this.$t('请选择'), trigger: ['blur', 'change'] }],
        Nature: [{ required: true, message: this.$t('请选择'), trigger: ['blur', 'change'] }],
        OccurTime: [{ required: true, message: this.$t('请选择'), trigger: ['blur', 'change'] }],
      }
    },
  },
  methods: {
    updateFile(val) {
      if (val.length) {
        this.formData.Snapshot = JSON.stringify(val)
      } else {
        this.formData.Snapshot = ''
      }
    },
    /**
     * @description 提交数据
     */
    subData() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        const params = {
          formCode: '1004',
          entity: this.formData,
        }
        const [err, res] = await formApi.insert({
          body: params,
        })
        if (err) return
        this.dialogVisible = false
        this.$message.success('提交成功')
        this.$emit('handleOk', this.formData.responseLevel)
      })
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.formLoading = true
          const [err, res] = await accidentEventsResponseDisposeApi.responseUprade({
            body: {
              id: this.propData.id,
              responseLevel: this.formData.responseLevel,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '响应升级成功',
              type: 'success',
            })
            this.$emit('handleOk', this.formData.responseLevel)
          }
          this.formLoading = false
        }
      })
    },
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['AccidentType', 'AccidentNature'],
        includeDetails: true,
      })
      if (err) return
      // 字典-事故类型
      const accidentType = res.find((item) => {
        return item.code === 'AccidentType'
      })
      this.accidentType = accidentType?.dataItems || []
      const accidentNature = res.find((item) => {
        return item.code === 'AccidentNature'
      })
      this.accidentNature = accidentNature?.dataItems || []
    },
    // 获取风险区域列表列表数据
    async getRiskData() {
      const data = {
        maxResultCount: 999, // 每页多少条
        skipCount: 0,
      }
      const [err, res] = await areaApi.getList(data)
      if (!err) {
        this.riskList = res.items
      }
    },
    // 获取应急预案列表数据
    async getPlanData() {
      const data = {
        maxResultCount: 999, // 每页多少条
        skipCount: 0,
      }
      const [err, res] = await planApi.getList(data)
      if (!err) {
        this.planList = res.items
      }
    },
  },
  created() {
    this.getRegulationType()
    this.getRiskData()
    this.getPlanData()
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-picker-panel {
  background: red !important;
}
::v-deep .el-upload-dragger {
  background-color: transparent;
}
</style>
